import React from 'react';

const NurturixCustomTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="tab-header">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default NurturixCustomTabs; 